import del from './delete';
import post from './post';
import put from './put';

export default { del, post, put };
